var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 476,
    height: 496,
    viewBox: "0 0 476 496",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M237.857 495.639C369.221 495.639 475.713 384.687 475.713 247.82C475.713 110.953 369.221 0 237.857 0C106.492 0 0 110.953 0 247.82C0 384.687 106.492 495.639 237.857 495.639Z",
    fill: "url(#paint0_radial_3252_7316)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_3252_7316",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(237.852 247.812) scale(237.863 247.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BEC8CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5311,
    stopColor: "#C0C8CA",
    stopOpacity: 0.4689
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9357,
    stopColor: "#C5CAC0",
    stopOpacity: 0.0642948
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C6CABE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.3e80706850db861a64c083d8914b76fe.svg";
export { ForwardRef as ReactComponent };